/*
 * Demo client entry. Mounts <App /> + injects the canvas-rendered close
 * and zoom button bitmaps as CSS custom properties so .be-window__close
 * and .be-window__zoom render correctly.
 */

import { createRoot } from "react-dom/client";

// Relative into the package's src/, NOT the `@beos-css/fonts-swis721/snap`
// export — that resolves to dist/be-snap.js, and demo pages must never import
// dist/ (it only refreshes on `bun run build`, which kills the dev server's
// instant change pickup). font-lab imports it the same way.
import { App } from "./App.tsx";
import { beBoot } from "./boot.ts";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("missing #root in index.html");
createRoot(rootEl).render(<App />);

/*
 * THE RUN-ORIGIN SNAP — the half of the treatment that was never running here.
 *
 * pixel-perfect.css was loaded and component labels carried .be-pixel-text, but
 * nothing ever called beSnapInit, so the site had only the CSS floor. On Gecko
 * that floor is `isolation + multiply` WITHOUT the snap — measured on real
 * Firefox-Windows (font-lab/probe/capture_stair.py, 8 sub-pixel phases) as
 * chroma 0 but a 90% loss of the glyph's opaque core: the black skeleton
 * dissolves into grey and neighbouring glyphs merge, which reads as soft text
 * with broken kerning.
 *
 * Snap + blend together is the only combination that passes all four gates
 * (chroma 0, L7, core intact, ink stable). Notes/49 §1.
 *
 * Deliberately after render(): the snapper measures live boxes, so it needs the
 * tree mounted. It re-snaps on resize, DPR change and webfont load by itself.
 *
 * Routed through beBoot() as of 2026-07-29 so it honours the data-be-pixel-text
 * gate, which is OFF by default — calling beSnapInit directly here would leave
 * this page treated while the stylesheet's levers stayed off, i.e. exactly the
 * half-a-treatment split the paragraph above is about, in the other direction.
 */
beBoot();
